<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content">
        <div class="main-title">通知列表</div>
        <el-table class="my-table" :data="tableData" stripe style="width: 100%" :row-class-name="tableRowClassName">
          <el-table-column width="20">
            <template slot-scope="scope">
              <el-badge v-if="scope.row.new == 1" is-dot class="item"></el-badge>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" width="260"></el-table-column>
          <el-table-column prop="content" label="内容"></el-table-column>
          <el-table-column prop="date" label="发送时间" width="180"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <span class="check-btn" @click="handleClick(scope.row)">查看</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "messageList",
  data() {
    return {
      active: 0,
      tableData: [
        {
          new: 1,
          date: "2016-05-02",
          title: "好设计是美的",
          content: "有功无过是短暂的，无功有过是行不通的，有功有过是最好的",
        },
        {
          new: 1,
          date: "2016-05-02",
          title: "好设计是美的",
          content: "有功无过是短暂的，无功有过是行不通的，有功有过是最好的",
        },
        {
          new: 0,
          date: "2016-05-02",
          title: "好设计是美的",
          content: "有功无过是短暂的，无功有过是行不通的，有功有过是最好的",
        },
        {
          new: 0,
          date: "2016-05-02",
          title: "好设计是美的",
          content: "有功无过是短暂的，无功有过是行不通的，有功有过是最好的",
        },
        {
          new: 0,
          date: "2016-05-02",
          title: "好设计是美的",
          content: "有功无过是短暂的，无功有过是行不通的，有功有过是最好的",
        },
      ],
    };
  },
  mounted() {
    // this.active = Number(localStorage.getItem("active")) || 0;
  },
  methods: {
    //根据列表返回状态，判断是否添加is-new 类名
    tableRowClassName({row}) {
        if (row.new === 1) {
          return 'is-new';
        }
        return '';
    },
    //跳转详情页
    handleClick(row){
      console.log(row, '===row')
      this.$router.push({ 
        path: '/messageDetails'
      });
    }
  },
};
</script>

<style lang="scss">
.my-table{
  color: #888;
  font-size: 18px;
  margin-top: 30px;
  
}
.my-table tbody td, .my-table tbody th{
  height: 70px;
  box-sizing: border-box;
}
.my-table tbody th, .my-table tbody tr{
  background: #F2F6FB;
}
.my-table tbody tr.is-new{
  color: #0E0E0E;
}
.my-table tbody tr td .check-btn{
  color:#1677FF;
  cursor: pointer;
}
.el-table--striped .el-table__body tr.el-table__row--striped td{
  background: #fff;
}
.el-table td, .el-table th.is-leaf{
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
.el-table--border::after, .el-table--group::after{
  width: 0;
}
.my-table::before{
  width: 0;
}
.my-table tbody tr td:first-child{
  border-radius: 10px 0 0 10px;
}
.my-table tbody tr td:last-child{
  border-radius: 0 10px 10px 0;
}
</style>